// extracted by mini-css-extract-plugin
export default {"wrapper":"UserProfileAdministrationInviteLabel_wrapper__ovNhn","icon":"UserProfileAdministrationInviteLabel_icon__+LChK"};